import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './../Header/Header';
import Footer from './../Footer';

const MainLayout: React.FC = () => {
    return (
        <div className="flex flex-col min-h-screen">
            <div className="fixed top-0 left-0 right-0 z-50">
            <Header  />
            </div>
            <main className="flex-grow mt-20">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default MainLayout;